import { Component, Vue } from 'vue-property-decorator'
import { PHONE_WIDTH, TABLET_PORTRAIT_WIDTH } from './constants'

@Component
export default class Mixin extends Vue {
  isPhone: boolean = window.innerWidth <= PHONE_WIDTH

  isTabletP: boolean = window.innerWidth > PHONE_WIDTH && window.innerWidth <= TABLET_PORTRAIT_WIDTH

  isPhoneAndTablet: boolean = window.innerWidth <= TABLET_PORTRAIT_WIDTH

  updateDeviceType(): void {
    this.isPhone = window.innerWidth <= PHONE_WIDTH
    this.isTabletP = window.innerWidth > PHONE_WIDTH && window.innerWidth <= TABLET_PORTRAIT_WIDTH
    this.isPhoneAndTablet = window.innerWidth <= TABLET_PORTRAIT_WIDTH
  }

  mounted(): void {
    setTimeout(() => window.addEventListener('resize', this.updateDeviceType), 0);
  }
}
